import { useLingui } from '@lingui/react/macro'

import { DialogHeader } from '@/layouts/Dialog'
import { useCloseModal } from '@/Router'
import { SpaceForm } from '@/features/space'

export default function CreateSpace() {
  const { t } = useLingui()
  const closeModal = useCloseModal()

  return (
    <div className="flex flex-col gap-7 p-5">
      <DialogHeader title={t`Create Room`} description={t`Create a new room`} />
      <SpaceForm onCancel={closeModal} onDone={closeModal} />
    </div>
  )
}
